export class CompPackOrderLessonProgramValues {

    constructor(lessonProjNr: number, lessonGroupNr: number, lessonDefNr: number, lessonProgramNr: number, lessonProgramProjNr: number, lessonProgramGroupNr: number) {
        this.lessonProjNr = lessonProjNr;
        this.lessonGroupNr = lessonGroupNr;
        this.lessonDefNr = lessonDefNr;
        this.lessonProgramNr = lessonProgramNr;
        this.lessonProgramProjNr = lessonProgramProjNr;
        this.lessonProgramGroupNr = lessonProgramGroupNr;
    }

    lessonProjNr: number;
    lessonGroupNr: number;
    lessonDefNr: number;
    lessonProgramNr: number;
    lessonProgramProjNr: number;
    lessonProgramGroupNr: number;
}